import { render } from "./SliderTabs.vue?vue&type=template&id=5e766b92&ts=true"
import script from "./SliderTabs.vue?vue&type=script&lang=ts"
export * from "./SliderTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__